export default function humanizeFileSize(size: number) {
  if (!size) return "0 B";
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return (
    (size / Math.pow(1024, i)).toFixed(i > 0 ? 2 : 0) +
    " " +
    ["B", "kB", "MB", "GB", "TB"][i]
  );
}
